import styled from "@emotion/styled";
import { fadeIn } from "~/styles/animation";

export const DivSpWrapper = styled.div`
  width: 100%;
  height: 100vh;
  height: calc(var(--1dvh, 1vh) * 100);
  height: 100dvh;
  box-sizing: content-box;
  padding-bottom: 100px;
  animation: ${fadeIn} 0.5s ease;
`;

export const ImgGravure = styled.img<{ isLoaded: boolean }>`
  width: 100%;
  padding-top: 16px;
  :last-of-type {
    padding-bottom: 16px;
  }
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
`;

export const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100vh;
  height: calc(var(--1dvh, 1vh) * 100);
  height: 100dvh;
`;
